
import { useTranslation } from 'react-i18next';
import { useState, useContext, useImperativeHandle, useEffect, useRef, forwardRef } from 'react';
import '../../../i18n'
import { Location } from '../../Checkout/Location/Location';
import { AddressFields } from './AddressFields';
import Button from '../../UI/Buttons/Button';
import { APIGet, APIPost, getEnvironment } from '../../API/APIRequest';
import { RecipientDeliveryDetails } from './RecipientDeliveryDetails';
import {  gtmEventTriggers } from '../../Utilities/GtmFunctions';
import { useAuth } from '../../Authentication/AuthenticationProvider';
import { GenericErrorBox } from '../../UI/ErrorBox/GenericErrorBox';
import { checkIsInvalid } from '../../Utilities/FieldValidations';
import { LatestAddress } from './LatestAddress';
import { getFilteredValues } from '../../Utilities/Functions';
import { AddressBlock } from '../../Utilities/AddressManagementUtils';



export const DeliveryDetails = forwardRef((props, ref) => {
  const { flags, 
    setSectionComplete, 
    setAlreadyPurchased, 
    fid, 
    setInitialFilledState,  
    initialFilledState, 
    optionalEmail, 
    phoneNumber, 
    giftRecipientDetails, 
    setOptionalEmail, 
    setPurchaseRestriction, 
    checkForBasketRestrictions, 
    variantIdCsv, 
    deliveryCountryCode, 
    companyProperties, 
    setCompanyProperties, 
    getAddressStructure, 
    deliveryAddressStructure, 
    showCompany, 
    loqateKey, 
    setBillingLoadingState, 
    guestSession, 
    setGiftRecipientDetails, 
    recipientDetails, 
    setRecipientDetails, 
    setLoading, 
    selectedAddress, 
    selectedCompany, 
    setSelectedAddress,
    setSelectedCompany, 
    IsFilled, 
    setIsFilled, 
    setDeliveryAddressStructure, 
    setDeliveryCountryCode, 
    sectionComplete,
    updateAndRefreshBasket,
    invalidState, 
    setInvalidState, 
    setBillingSectionLoading,
    latestDeliveryDetails,
    usingLatestDeliveryDetails,
    setUsingLatestDeliveryDetails } = props;

  const { t, i18n } = useTranslation();
  const { basket, loading } = props
  const [countryCode, setCountryCode] = useState(deliveryCountryCode)
  const [countyCode, setCountyCode] = useState();
  const [IsInvalid, setIsInvalid] = useState({ userEmail: false, firstName: false, lastName: false });
  const [showContinueButton, setShowContinueButton] = useState(false)
  const [countryList, setCountryList] = useState(basket.countries || JSON.parse(sessionStorage.getItem("deliveryCountryList")));
  const [errors, setErrors] = useState([]);
  const recipientRef=useRef();
  const [editMode, setEditMode] = useState(false);
  const [initialInvalidState, setInitialInvalidState]=useState({});
  const [environment, setEnvironment] = useState(getEnvironment());
  const [addressStructure, setAddressStructure] = useState([]);
  const [latestAddress, setLatestAddress] = useState(null);
  //country code resolved from the latest address, used to pre-select the country dropdown on "change address"
  const [latestAddressCountryCode, setLatestAddressCountryCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const fieldRef = useRef();
  const countryRef = useRef(null);
  const deliveryErrorFocusRef=useRef(null);
  const params = new URLSearchParams(window.location.search);
  const purchasingFor= params.get("purchasingFor");
  const auth = useAuth();
  const [fieldsLoading, setFieldsLoading] = useState(false);

  useEffect(() => {
    if (countryCode && countryCode !== deliveryCountryCode) {
      setBillingSectionLoading(true);
      setDeliveryCountryCode(countryCode) 
      setSelectedAddress(selectedAddress => ({ COUNTRY: selectedAddress.COUNTRY })) ;
      setSelectedCompany({}); //blanking out data obj as country changes
      getAddressStructure(countryCode, fid)
      updateAndRefreshBasket(countryCode,"destinationcountrycode");
    }
  }, [countryCode])

  useEffect(()=>{
   if(countryList.length===0){
    setCountryList(basket.countries);
  }
  sessionStorage.setItem("deliveryCountryList", JSON.stringify(basket.countries)) 
  }, [fid, basket.id])



 useEffect(()=>{
    setAddressStructure(deliveryAddressStructure);
    if (flags.isdeliverypostaladdressrequired) {
        addressFieldsMap(deliveryAddressStructure)
    }
  }, [deliveryAddressStructure])


  const addressFieldsMap = (addressfields) => {
    addressfields.map((field, index) => {
      if (field.fieldName !== "COUNTRY") {
        //so that on state change from manual to lookup we can retain the original isFilled state
        setInitialFilledState(initialFilledState => ({...initialFilledState, [field.fieldName]: { ...initialFilledState[field.fieldName], filled: true, mandatory: field.mandatory } }));
        setInitialInvalidState(initialInvalidState => ({...initialInvalidState, [field.fieldName]: { ...initialInvalidState[field.fieldName], invalid: false, mandatory: field.mandatory } }));
        }
    })
  }

 function scrollToOffset(offset) {
    const duration = 200; // Animation duration in milliseconds
    const startY = window.pageYOffset || document.documentElement.scrollTop;
    const targetY = offset;
    const distance = targetY - startY;
    const startTime = performance.now();
    
    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const nextPosition = startY + distance * (elapsed / duration);
      window.scrollTo(0, nextPosition);
      
      if (elapsed < duration) {
        window.requestAnimationFrame(step);
      }
    }
    
    window.requestAnimationFrame(step);
  }

  //for checking the variant type in order to show email field for recipient or not
  const checkProductTypeForGiftUser = (e) => {
    
   let typeArray = basket?.producttypes;
  
    typeArray.find((item, i)=>{
      //presence of sundry variant would not make a difference
      if(item!=="Print" && item!=="Sundry"){
        setOptionalEmail(false);
       }
     })
  }

 //on-mount
  useEffect(() => {

    checkProductTypeForGiftUser();

   }, [])



 const SaveGiftRecipientDetails = (e) => {
    setErrors("")
   
    e.preventDefault();

    let userDataString = sessionStorage.getItem("adtoken");
    let userData = JSON.parse(userDataString);
    let validation=validateDeliveryDetails(e);
    let validationStatus=validation.status;
    let reciDetails=validation.details;
    setRecipientDetails(reciDetails);
   
    if(validationStatus){

      let postData= {
        fid: basket?.id,
        email: reciDetails?.userEmail || null,
        firstName: reciDetails?.firstName,
        surname: reciDetails?.lastName,
        addressLine1 : selectedAddress?.ADDRESS1 || null,
        postcode: selectedAddress?.POSTCODE || null,
        country:selectedAddress?.COUNTRY || null
       }

      APIPost({
      "controller": "auth",
      "action": "creategiftuser",
      "environment": environment,
      "headers": [{
        "key": "UserToken",
        "value": auth?.userData?.token || userData?.token}], 

       data: postData

    }).then((response) => {
      
    let user = response?.data?.user;
     
      if(user){
      let giftUser = {
        "name": user?.userfullname,
        "token": user?.userToken,
        "username": user?.username,
        "partyid": user?.partyid
      };

      checkForBasketRestrictions(user?.partyid, user?.username, basket)
      setGiftRecipientDetails(giftUser);
   
      if(basket.allowgifting){
        setSectionComplete(sectionComplete => ({ ...sectionComplete, deliveryDetails: true}))
        scrollToOffset(340);
        saveDeliveryDetailsToSession(reciDetails, giftUser); 
          
      }}

    }).catch((error) => {
     
      var unexpected = [];
      unexpected.push("error.unexpected");
      setErrors(unexpected);
      setIsLoading(false); 
      
    });
}
}


//settings for reinstating basket after the reload
const saveDeliveryDetailsToSession=(reciDetails, giftUser)=>{
      //make a copy of selected address
    
      //storing delivery details
      let deliveryDetailsToShow=  {
        "recipient": ((purchasingFor==="gift" && basket.allowgifting)  || (!purchasingFor && basket.allowgifting)) ? {
        "userEmail":  reciDetails?.userEmail ,
        "firstName":  reciDetails?.firstName ,
        "lastName":  reciDetails?.lastName} : {}, 
        "giftRecipientDetails":{
        "token" : giftUser?.token || "",
        "partyid" : giftUser?.partyid || ""},
        "company": selectedCompany,
        "address": selectedAddress,
        "phoneNumber": phoneNumber,
        "IsFilledDelivery":IsFilled,
        "countryCode":countryCode,
        "countyCode":countyCode
        
        
      }
    
      if(deliveryDetailsToShow?.address?.COUNTRY){
        sessionStorage.setItem("sessionDeliveryDetails", JSON.stringify(deliveryDetailsToShow));
      }
}

const focusOnFirstError = () => {
  setTimeout(() => {
      let firstElement = deliveryErrorFocusRef.current?.querySelectorAll("input[invalidclass='Invalid-input']")[0]
      firstElement?.focus();
  }, 200)

}

  const validateDeliveryDetails = (e) => {
    e.preventDefault();
    setIsLoading(true)   // set local loading state to be true
    setBillingLoadingState(true); 
   
    let detailsFilled = true;
    let recipientDetailsFilled=true;
    let recipient;
    
    let newIsFilled = { ...IsFilled };
    let newIsInvalid = { ...IsInvalid };

    if (flags.isdeliverypostaladdressrequired) {
        if (selectedAddress.ADDRESS1 === undefined) {
            newIsFilled = { ...newIsFilled, ADDRESS: { filled: false, mandatory: true } };
            detailsFilled = false
        }
    }  

    if (!selectedAddress.COUNTRY) {
        newIsFilled = { ...newIsFilled, COUNTRY: { filled: false, mandatory: true } }
        detailsFilled = false
    }

   if(( purchasingFor==="gift" && basket.allowgifting)  || (!purchasingFor && basket.allowgifting)){

       recipient=recipientRef?.current?.ValidationOnSubmit()
       detailsFilled=recipient?.status;

   }
   
   //for checking company field
   if(!selectedCompany?.COMPANY  && IsFilled.COMPANY?.mandatory && showCompany){
      newIsFilled = { ...newIsFilled, COMPANY: { filled: false, mandatory: true } }
      detailsFilled = false
   }
  
   //for validation of company value
    if (selectedCompany?.COMPANY?.length > 0 && checkIsInvalid(selectedCompany?.COMPANY, "address")) {
      newIsInvalid ={ ...newIsInvalid, COMPANY: { invalid: true, mandatory: false } }
      detailsFilled = false
    }
    else {
      newIsInvalid ={ ...newIsInvalid, COMPANY: { invalid: false, mandatory: false } }
    }
   

    if(flags.isdeliverypostaladdressrequired){
    for (let key in IsFilled) {
   
      if (key !== "ADDRESS" && key !== "RECIPIENT" && key !== "COMPANY") {
          if ((!selectedAddress[key] || selectedAddress[key] === '') && IsFilled[key]?.mandatory) {
              newIsFilled = { ...newIsFilled, [key]: { filled: false, mandatory: true } }
              detailsFilled = false
          }
          else if ((selectedAddress[key] && selectedAddress[key] !== '') && checkIsInvalid(selectedAddress[key], "address")) {
            newIsInvalid = { ...newIsInvalid, [key]: { invalid: true, mandatory: true } };
            detailsFilled = false
          }
        }
      }
    }


    setIsFilled({ ...newIsFilled })
    setIsInvalid({ ...newIsInvalid })
    //for non-gift the validation will be completed here
    setTimeout(()=>{
    
      setBillingLoadingState(false);
      setLoading(false);
    
    },[500])
    
    if(!basket.allowgifting){
    scrollToOffset(340);
    }

    if (!detailsFilled) {

      setIsLoading(false);
      focusOnFirstError();

    } else {
    
      if(!basket.allowgifting){
        setSectionComplete(sectionComplete => ({ ...sectionComplete, deliveryDetails: detailsFilled }))
        saveDeliveryDetailsToSession(); 
      }

      if (flags?.isdeliverypostaladdressrequired || (purchasingFor === "gift" && basket?.allowgifting)) {
        gtmEventTriggers("add_shipping_info") //when delivery details are needed then on validation event will be triggered
       }
     
    }
    
    if(basket.allowgifting){
      return {status: detailsFilled, details:recipient?.details}
    }
    else{
      return detailsFilled;
  }

}

 //edit delivery details
  const handleOnEdit = () => {

    setErrors("")
    setEditMode(true);
    setIsLoading(false);
    sessionStorage.removeItem("sessionDeliveryDetails");
    setSectionComplete({ ...setSectionComplete, deliveryDetails: false });
    setAlreadyPurchased({status:"", text:""});
    setPurchaseRestriction({status:"", text:""});
   

   }


   //latest address- bits------------------------------------------------------------------------------------------------------------------------------------------

   const handleOnChangeLatestAddress = ()=>{
        setUsingLatestDeliveryDetails(false);
        setGiftRecipientDetails({});
        setSectionComplete({ ...setSectionComplete, deliveryDetails: false });
        sessionStorage.removeItem("sessionDeliveryDetails");
   }
   


const deliveryAddressUI = () => (
  <AddressBlock address={selectedAddress} company={selectedCompany} includeCompany />
);


  const recipientDetailsUI=()=>{
    let recipientDetailsUI = <>
    <p>{recipientDetails.firstName} {recipientDetails.lastName}</p>
    <p>{recipientDetails.userEmail}</p>
    </>
    return recipientDetailsUI;
  }


  useEffect(() => {

    if (selectedAddress?.COUNTRY) {

      //country is always mandatory
      setIsFilled({ COUNTRY: {  filled: true, mandatory: true } })
    
    if(!flags?.isdeliverypostaladdressrequired && !basket.allowgifting){
        saveDeliveryDetailsToSession();    //saving delivery details here for digital online variants
      }
    }

  }, [selectedAddress.COUNTRY])


  useEffect(() => {
    if (!flags?.isdeliverypostaladdressrequired && !basket?.allowgifting) {
      setUsingLatestDeliveryDetails(false)
    }

  }, [basket])



  //add gift user state too 

  return (
  
    <>
    
    {  //needs to change to cover allow gifting
    (usingLatestDeliveryDetails && (flags?.isdeliverypostaladdressrequired || basket?.allowgifting)) ? 
    
         <LatestAddress
         fid={fid}
         type="delivery"
         setSectionComplete={setSectionComplete}
         deliveryAddressUI={deliveryAddressUI} 
         selectedCompany={selectedCompany}
         selectedAddress={selectedAddress}
         setSelectedAddress={setSelectedAddress} 
         setSelectedCompany={setSelectedCompany} 
         usingLatest={usingLatestDeliveryDetails}
         setUsingLatest={setUsingLatestDeliveryDetails}
         handleOnChangeAddress={handleOnChangeLatestAddress}
         setLatestAddressCountryCode={setLatestAddressCountryCode}
         setRecipientDetails={setRecipientDetails}
         setGiftRecipientDetails={setGiftRecipientDetails}
         showAddressUI = {deliveryAddressUI}
         showRecipientUI = {recipientDetailsUI}
         isGift={basket?.allowgifting}
         isPrint={flags?.isdeliverypostaladdressrequired}
         optionalEmail={optionalEmail}
         basketCountryCode={deliveryCountryCode}
         countryList={countryList}
         updateAndRefreshBasket={updateAndRefreshBasket}
         />  
      
      :
     //needs to change to cover allow gifting
     (!usingLatestDeliveryDetails) ?  

     
    ((sectionComplete?.deliveryDetails && flags.isdeliverypostaladdressrequired) || (basket.allowgifting && sectionComplete?.deliveryDetails)) ?
      <div className="address-block">
       <button onClick={() => { handleOnEdit() }}>{t("checkout.editbuttonlabel")}</button> 
        

        {(purchasingFor==="gift" && basket.allowgifting )  || (!purchasingFor && basket.allowgifting )  ?  <>  
        <div className="detail-wrapper">
       
        <div className="item-wrapper">
          <p><strong>{t("checkout.recipientlabel")}</strong></p>
          <p>{recipientDetailsUI()}</p>
          </div>
         
         {!flags?.hidedeliverydetails && 
          <div className="item-wrapper">
          <p><strong>{t("checkout.addresslabel")}</strong></p>
          <p>{deliveryAddressUI()}</p>
          </div> }
          </div>
          
        
        </> : <div className="detail-wrapper">
          <p>{deliveryAddressUI()}</p>
         </div>}
      </div>

    

      :

      <>
      
      <form  ref={deliveryErrorFocusRef} onSubmit={(purchasingFor==="gift" && basket.allowgifting)  || (!purchasingFor && basket.allowgifting) ? SaveGiftRecipientDetails : validateDeliveryDetails}>

         <GenericErrorBox errors={errors} /> 
      
        { (( purchasingFor==="gift" && basket.allowgifting )  || (!purchasingFor && basket.allowgifting)) ? 
       
        <RecipientDeliveryDetails detailType="recipient" 
        ref={recipientRef}
        setRecipientDetails={setRecipientDetails}  
        recipientDetails={recipientDetails}
        IsFilled={IsFilled}  
        optionalEmail={optionalEmail}
        setIsFilled={setIsFilled}
        setIsInvalid={setIsInvalid}
        IsInvalid={IsInvalid}

         />: "" }

         {/* when hidedeliverydetails is true and allowgifting is true then delivery block will show but do not show location */}
         {flags?.isdeliverycountryrequired && !flags?.hidedeliverydetails ? 
          <Location countryList={countryList}
            addressType="deliveryAddress"
            setCountryCode={setCountryCode}
            countryCode={countryCode}
            IsFilled={IsFilled}
            id="delivery-country"
            name="delivery-country"
            basket={basket}
            preSelectedCountryCode={latestAddressCountryCode || deliveryCountryCode || basket?.destinationcountrycode || basket.countrycode}
            setIsFilled={setIsFilled}
            setSelectedAddress={setSelectedAddress}
            selectedAddress={selectedAddress} />
          : ""}

        {flags?.isdeliverypostaladdressrequired && countryCode ?
          <>
                          <AddressFields companyList={props.companyList}
                              addressType="deliveryAddress"
                              setFieldsLoading={setFieldsLoading}
                              fieldsLoading={fieldsLoading}
                              countryCode={countryCode}
                              countryRef={countryRef}
                              loading={loading}
                              showCompany={showCompany}
                              initialFilledState={initialFilledState}
                              IsFilled={IsFilled}
                              setIsFilled={setIsFilled}
                              ref={fieldRef}
                              loqateKey={loqateKey}
                              setSelectedCompany={setSelectedCompany}
                              selectedCompany={selectedCompany}
                              setSelectedAddress={setSelectedAddress}
                              selectedAddress={selectedAddress}
                              addressStructure={addressStructure}
                              editMode={editMode}
                              showContinueButton={showContinueButton}
                              setShowContinueButton={setShowContinueButton}
                              setEditMode={setEditMode}
                              companyProperties={companyProperties}
                              setCompanyProperties={setCompanyProperties}
                              isGift={purchasingFor}
                              setIsInvalid={setInvalidState}
                              IsInvalid={invalidState}
                              initialInvalidState = {initialInvalidState}
                              updateAndRefreshBasket={updateAndRefreshBasket}
                              setCountyCode={setCountyCode}
            />
              {showContinueButton ?
                (!isLoading ? <Button type="submit" id="deliverySubmit">{t('deliverydetails.submitbuttontext')}</Button>
                  : isLoading ? <Button type="submit" hasIcon="updating" isDisabled="true" buttonSize="small">{t('deliverydetails.submitbuttontext')}</Button>
                    :"" )
           : ""}
        
          </> : ""}
          
          {(!flags?.isdeliverypostaladdressrequired && ((purchasingFor === "gift" && basket?.allowgifting) || (!purchasingFor && basket?.allowgifting))) ?
          
            (!isLoading ? <Button id="deliverySubmit" type="submit">{t('deliverydetails.submitbuttontext')}</Button>
              : isLoading ? <Button type="submit" hasIcon="updating" isDisabled="true" buttonSize="small">{t('deliverydetails.submitbuttontext')}</Button>
                : "") : ""}
     </form>
      </>
          
    : ""
    
    }

    </>
  );
})